import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { UserStateService } from '../../core/services/user.state.service';
import { NavigationService } from '../../core/services/navigation.service';
import { PATHS } from '../models/paths';


@Injectable({
  providedIn: 'root',
})
export class NotAuthenticatedGuard implements CanActivate {
  private readonly userStateService = inject(UserStateService);
  private readonly navigationService = inject(NavigationService);

  public canActivate(
    route: ActivatedRouteSnapshot
  ): MaybeAsync<GuardResult> {
    if (!this.userStateService.user()) {
      return true;
    } else {
      const folderId = route.params['folderId'];
      if (folderId) {
        void this.navigationService.navigate(PATHS.listTranscriptions());
        return false;
      } else {
        void this.navigationService.navigate(PATHS.defaultPage());
        return false;
      }
    }
  }
}
